// German translations
const de = {
    common: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        close: 'Schließen',
        edit: 'Bearbeiten',
        reset: 'Zurücksetzen',
        delete: 'Löschen',
        loading: 'Laden...',
        required: 'Pflichtfeld',
        error: 'Fehler',
        success: 'Erfolg',
        optional: 'Optional',
        create: 'Erstellen',
        search: 'Suchen',
        add: 'Hinzufügen',
        selectDate: 'Datum auswählen',
        years: 'Jahre',
        amount: 'DS unterschrieben',
        month: 'Monat',
        months: 'Monate',
        action: 'Aktion',
        actions: 'Aktionen',
        invoice: 'Rechnung',
        export: 'Exportieren',
        filter: 'Filter',
        statusfilter: 'Statusfilter',
        all: 'Alle',
        invoiceDate: 'Rechnungsdatum',
        invoiceNumber: 'Rechnungsnummer',
        statementReceivedDate: 'Abrechnung erhalten am',
        statementReceivedNumber: 'Abrechnungsreferenz',
        invoiceAmount: 'Rechnungsbetrag',
        invoiceStatus: 'Rechnungsstatus',
        invoiceType: 'Rechnungsart',
        selectConsultant: 'Berater auswählen',
        pleaseEnterInvoiceDate: 'Bitte Rechnungsdatum eingeben',
        pleaseEnterInvoiceNumber: 'Bitte Rechnungsnummer eingeben',
        validation: {
            required: 'Dieses Feld ist erforderlich',
            invalidAmount: 'Ungültiger Betrag',
            invalidDate: 'Ungültiges Datum',
            invalidEmail: 'Ungültige E-Mail-Adresse',
            invalidNumber: 'Ungültige Nummer',
            invalidUrl: 'Ungültige URL',
            invalidPhone: 'Ungültige Telefonnummer',
            invalidPassword: 'Ungültiges Passwort',
            invalidPasswordMatch: 'Passwörter stimmen nicht überein',
            invalidOption: 'Bitte wählen Sie eine gültige Option aus der Liste',
            invalidCustomerOption: 'Bitte vorhandenen Kunden auswählen oder über "Kunde anlegen" anlegen',
        },
        total: 'Gesamt',
    },

    navigation: {
        main: {
            dashboard: 'Dashboard',
            loans: 'Meine Vorgänge',
            customers: 'Kunden',
            analytics: 'Auswertungen',
            consultantAnalytics: 'Auswertung Berater',
            bankAnalytics: 'Auswertung Banken',
            billing: 'Meine Abrechnung',
            settings: 'Einstellungen',
            logout: 'Abmelden',
            login: 'Anmelden',
            withdrawalPassed: 'Hyplife Abrechnung',
            paymentConfirmed: 'Hyplife Zahlungseingang',
            paid: 'Bezahlt',
            clients: 'Kunden',
            accounting: 'Abrechnung',
            consultantBilling: 'Beraterabrechnung',
            administration: 'Admin&Buchhaltung',
            banks: 'Stammdaten Banken',
            poolers: 'Pooler',
            referrers: 'Stammdaten Makler',
            myAnalytics: 'Meine Auswertung',
        },
        accountant: {
            consultantBillingAdmin: 'Beraterabrechnung eintragen',
            consultantBillingAdminOverview: 'Beraterabrechnungen',
            loansAdmin: 'Alle Vorgänge'
        },
        user: {
            profile: 'Profil',
            logout: 'Abmelden'
        }
    },
    auth: {
        login: {
            title: 'Anmelden',
            email: 'E-Mail',
            password: 'Passwort',
            submit: 'Anmelden',
            error: 'Anmeldung fehlgeschlagen',
            usernameRequired: 'Bitte geben Sie Ihren Benutzernamen ein',
            passwordRequired: 'Bitte geben Sie Ihr Passwort ein'
        }
    },
    loan: {
        title: 'Vorgänge',
        subtitle: 'Hier kannst du Deine Vorgänge einsehen und exportieren.',
        subtitleAdmin: 'Hier kannst du Vorgänge einsehen und editieren.',

        addLoan: 'Vorgang anlegen',        
        search: 'Suche',
        create: 'Erfolgreich melden',
        addmore: 'Finanzierungsbaustein speichern',
        createCustomer: 'Kunde anlegen',
        status: {
            default: {
                PENDING: 'Prognose',
                IN_WITHDRAWAL: 'Widerrufsfrist',
                WITHDRAWAL_PASSED: 'Widerrufsfrist abgelaufen',
                PAYMENT_CONFIRMED: 'Zahlung angefordert',
                PAID: 'Zahlungseingang',
                CONSULTANT_BILLED: 'Abgerechnet',
                CANCELLED: 'Storniert'
            },
            consultant: {
                PENDING: 'Prognose',
                IN_WITHDRAWAL: 'Widerrufsfrist',
                WITHDRAWAL_PASSED: 'Warten auf Bezahlung',
                PAYMENT_CONFIRMED: 'Warten auf Bezahlung',
                PAID: 'Abrechenbar',
                CONSULTANT_BILLED: 'Ausbezahlt',
                CANCELLED: 'Storniert'
            }
        },
        fields: {
            processNumber: 'Vertragsnummer',
            loanParts: 'Finanzierungsbausteine',
            loan: 'Finanzierungsbaustein',
            customer: 'Kunde',
            amount: 'Darlehenssumme',
            loanType: 'Kreditart',
            loanTypeSelect: 'Kreditart auswählen',
            bank: 'Bank',
            bankSelect: 'Bank auswahlen',
            interestLock: 'Zinsbindung in Jahren',
            referredByMakler: 'Vermittelt durch Makler',
            referredByCustomer: 'Vermittelt durch Kunde',
            consultants: 'Berater',
            primaryConsultant: 'Hauptberater',
            loanPart: 'Baustein',
            temporaryConsultant: 'Vertreter',
            reportedAt: 'Meldedatum',
            signatureDate: 'Unterschriftsdatum',
            status: 'Status',
            createdAt: 'Erstellt am',
            updatedAt: 'Aktualisiert am',
            provision: 'Provision in %',
            commission: 'Provision',
            evaluationAmount: 'Bewertungssumme',
            primaryShare: 'Anteil Hauptberater',
            temporaryShare: 'Anteil Vertreter',
            holidayReplacement: 'Anteil Vertreter',
            referredBy: 'Vermittelt durch',
            extraBonus: 'Extra Bonus in Euro',
            extra_bonus: 'Bonus',
            incentive_amount: 'Rechnungsbetrag Bank',
            invoiceNumber: 'Rechnungsnummer',
            directSubmission: 'Direkteinreichung',
            prognosis: 'Prognose',
            commissionTier: 'Provisionstufe',
            pooler: 'Pooler',
            poolerShare: 'Pooler Anteil',
            poolerCommission: 'Pooler Provision',
            primary_share: 'Hauptberater Anteil',
            temporary_share: 'Vertreter Anteil',
            detailed_status: 'Status',
            paymentDate: 'Zahlungsdatum',
            statementReceivedDate: 'Kontoauszug erhalten am',
            billingNumber: 'Rechnungsnummer',
            billingDate: 'Rechnungsdatum',
            type: 'Typ',
            loanCount: 'Anzahl Vorgänge',
            totalAmount: 'Gesamtvolumen',
            totalExtraBonus: 'Gesamt Bonus',
            totalInvoiceSum: 'Rechnungsbetrag',
            totalProvision: 'Gesamtprovision',
            consultantShare: 'Berateranteil',
            consultantProvision: 'Beraterprovision',
            payout_sum: 'Summe',
            invoice_comment: 'Anmerkung'
        },
        filter: {
            title: 'Filter',
            subtitle: 'Filtere die Vorgänge nach verschiedenen Kriterien',
            year: 'Jahr',
            consultant: 'Berater',
            status: 'Status',
            apply: 'Anwenden',
            reset: 'Zurücksetzen',
        },
        consultant: {
            primary: 'Hauptberater',
            secondary: 'Zweitberater',
        },
        billing: {
            accounting: 'Abrechnung',
            invoiceInfo: 'Rechnungsdaten',
            statementInfo: 'Abrechnungsdaten',
            bankBillingInfo: 'Bankabrechnung',  
            consultantBillingInfo: 'Beraterabrechnung',
            temporaryBilling: 'Vertreterabrechnung',
            invoiceDate: 'Rechnungsdatum',
            invoiceNumber: 'Rechnungsnummer',
            statementReceivedDate: 'Abrechnung erhalten am',
            statementReceivedNumber: 'Abrechnungsreferenz',
            paymentDate: 'Zahlungsdatum',
            consultantBilledDate: 'Berater abgerechnet am',
            consultantBilledNumber: 'Beratungsrechnungsnummer',
            temporaryBilledDate: 'Vertreter abgerechnet am',
            temporaryBilledNumber: 'Vertreter Rechnungsnummer',
            selectConsultant: 'Berater auswählen',
            invoiceComment: 'Rechnungskommentar',        },
        details: {
            title: 'Vorgang',
            subtitle: 'Hier kannst du Deinen Vorgang einsehen und editieren.',
            basicInfo: 'Grundinformationen',
            loanInfo: 'Finanzierungsinformationen',
            billing: 'Abrechnung Berater',
            payment: 'Abrechnung Bank',
            commission: 'Provisionen & Bonus',       

        },
        edit: {
            title: 'Vorgang bearbeiten',
            subtitle: 'Hier kannst du Deinen Vorgang editieren.',
        },
        validation: {
            required: 'Dieses Feld ist erforderlich',
            invalidAmount: 'Ungültige Darlehenssumme',
            processNumber: 'Bitte geben Sie eine Vertragsnummer ein',
            customer: 'Bitte wählen Sie einen Kunden aus',
            loanType: 'Bitte wählen Sie eine Kreditart aus',
            bank: 'Bitte wählen Sie eine Bank aus',
            amount: 'Bitte geben Sie einen Betrag ein',
            provision: 'Bitte geben Sie eine Provision ein',
            interestLockInYears: 'Bitte wählen Sie eine Zinsbindung aus',
            signatureDate: 'Bitte geben Sie ein Unterschriftsdatum ein',
            reportedAt: 'Bitte geben Sie ein Meldedatum ein',
            invalidProvision: 'Ungültige Provision',
            invalidInterestLockInYears: 'Ungültige Zinsbindung',
            invalidOption: 'Bitte wählen Sie eine gültige Option aus der Liste'
        },
        messages: {
            createSuccess: 'Kredit wurde erfolgreich erstellt',
            updateSuccess: 'Kredit wurde erfolgreich aktualisiert',
            paymentConfirmed: 'Zahlungseingang wurde vermerkt',
            requiredFieldsMissing: 'Bitte die Pflichtangaben ausfüllen',
            saveFailed: 'Fehler beim Speichern des Kredits',
            loadingFailed: 'Fehler beim Laden des Kredits',
            duplicateProcessNumber: 'Die Vertragsnummer existiert bereits. Bitte geben Sie eine andere Nummer ein.',
        },
        delete: {
            confirmTitle: 'Kredit löschen',
            confirmText: 'Sind Sie sicher, dass Sie diesen Kredit löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
            enterCode: 'Bitte geben Sie den folgenden Code ein, um das Löschen zu bestätigen:',
            codePlaceholder: 'Bestätigungscode eingeben',
            success: 'Kredit wurde erfolgreich gelöscht',
            error: 'Fehler beim Löschen des Kredits'
        },
        cancel: {
            success: 'Kredit wurde erfolgreich storniert',
            error: 'Fehler beim Stornieren des Kredits'
        },
    },
    loanNew: {
        title: 'Neuer Vorgang',
        subtitle: 'Hier kannst du einen neuen Vorgang erstellen.',
    },
    customer: {
        title: 'Kunden',
        subtitle: 'Hier kannst du Kunden einsehen und exportieren.',
        addCustomer: 'Kunde anlegen',
        loans: 'Vorgänge',
        search: 'Suche',
        onlyMyCustomers: 'Nur meine Kunden',
        fields: {
            address: 'Adresse',
            contactInfo: 'Kontaktinformationen',
            personalInfo: 'Persönliche Informationen',
            name: 'Name',
            firstName: 'Vorname',
            lastName: 'Nachname',
            street: 'Straße',
            houseNumber: 'Hausnummer',
            zipCode: 'PLZ',
            city: 'Stadt',
            email: 'E-Mail',
            phone: 'Telefon',
            mobile: 'Mobiltelefon',
            dateOfBirth: 'Geburtsdatum',
            addressSearch: 'Vollständige Adresse',
            searchPlaceholder: 'Bitte hier die vollständige Adresse eingeben'
        },
        modal: {
            title: 'Kunde anlegen',
        },
        messages: {
            createSuccess: 'Kunde erfolgreich angelegt',
            createError: 'Fehler beim Anlegen des Kunden',
            deleteSuccess: 'Kunde erfolgreich gelöscht',
            deleteError: 'Fehler beim Löschen des Kunden',
            deleteConfirm: 'Möchten Sie diesen Kunden wirklich löschen?',
            fetchError: 'Fehler beim Laden der Kundendaten'
        },
        createSuccess: 'Kunde erfolgreich angelegt',
        createError: 'Fehler beim Anlegen des Kunden'
    },
    billing: {
        title: 'Abrechnung',
        subtitle: 'Hier kannst du deine Abrechnungen verwalten',
        addInvoice: 'Neue Rechnung erstellen',
        createInvoice: 'Rechnung erstellen',
        viewInvoices: 'Rechnungen einsehen',
        missingFields: {
            title: 'Fehlende Daten für Rechnungserstellung',
            description: 'Um Rechnungen erstellen zu können, müssen Sie Ihre Adressdaten (Straße, PLZ, Stadt, IBAN, Steuernummer) in Ihren Profileinstellungen vervollständigen.',
            link: '>> Zu den Profileinstellungen'
        },
        overview: {
            title: 'Abrechnungsübersicht',
            subtitle: 'Übersicht aller abgerechneten Vorgänge',
            actions: 'Aktionen',
            downloadInvoice: 'Rechnung herunterladen',
            preview: 'Rechnungsvorschau'
        },
        primary_consultant_loans: 'Abrechenbar',
        temporary_consultant_loans: 'Als Vertreter abrechenbar',
        withdrawal_loans: 'Vorschuss',

        metrics: {
            sumPrimaryShare: 'Betrag Hauptberater',
            sumTemporaryShare: 'Betrag Vertreter',
            sumExtraBonus: 'Betrag Extra Bonus',
            sumWithdrawal: 'Betrag Vorschuss',
            sumTotal: 'Gesamt',
        },
        billingOverview: 'Abrechnungsübersicht',
    },

    dashboard: {
        title: 'Dashboard',
        subtitle: 'Übersicht',
        metrics: {
            totalVolume: 'Gesamtvolumen',
            total: 'Gesamtprovision (offen)',
            totalProvision: 'Gesamtprovision',
            averageVolume: 'Durchschnittsvolumen',
            pendingLoans: 'Offene Kredite',
            signedLoans: 'Unterschriebene Kredite',
            evaluationAmount: 'Bewertungssumme',
            totalCommission: 'Gesamtprovision YTD',
            forecastCommission: 'Prognostizierte Provision',
            totalLoans: 'Anzahl Kredite',
            in_withdrawal: 'Provisionen in Widerrufsfrist',
            withdrawal_passed: 'Warten auf Bezahlung',
            payment_confirmed: 'Überweisung ausstehend',
            paid: 'Abrechenbare Provisionen',
            consultant_billed: 'Beraterabrechnung'
        },
        status: {
            in_withdrawal: 'Provision in Widerrufsfrist',
            withdrawal_passed: 'Provision in Widerrufsfrist abgelaufen',
            payment_confirmed: 'Provisionen Abgerechnet',
            paid: 'Provision Bezahlt',
            consultant_billed: 'Beraterabrechnung',
            cancelled: 'Storniert'
        },
        charts: {
            title: 'Monatliche Übersicht',
            evaluationAmount: 'Bewertungssumme',
            primaryCommission: 'Erstberater Provision',
            extraBonus: 'Extra Bonus',
            secondaryCommission: 'Zweitberater Provision',
            totalCommission: 'Gesamt Provision'
        },
        signatures: {
            title: 'Unterschriften ausstehend',
            modalTitle: 'Unterschrift hinzufügen',
            dateRequired: 'Bitte wählen Sie ein Datum aus',
            success: 'Unterschrift erfolgreich hinzugefügt',
            error: 'Fehler beim Hinzufügen der Unterschrift',
            selectDate: 'Datum auswählen',
            addSignature: 'Unterschrift hinzufügen'
        },
        primaryConsultant: {
            title: 'Kredite als Hauptberater'
        },
        temporaryConsultant: {
            title: 'Kredite als Vertreter'
        },
        month: 'Monat'
    },
    analytics: {
        title: 'Auswertung Berater',
        subtitle: 'Vergleich der Standorte & Berater',
        filters: {
            year: 'Jahr',
            location: 'Standort',
            allLocations: 'Alle Standorte',
            consultant: 'Berater',
            compareYear: 'Vergleiche mit Jahr',
            allConsultants: 'Alle Berater'
        },
        kpis: {
            totalAmount: 'Gesamtkreditsumme',
            totalLoans: 'Anzahl Vorgänge',
            avgAmount: 'Ø Kreditsumme',
            totalCommission: 'Gesamtprovision',
            withdrawalRate: 'Widerrufsquote',
            conversionRate: 'Abschlussquote',
            avgTimeToClose: 'Ø Tage Unterschrift bis Auszahlung',
            yearlyGoalProgress: 'Jahresziel im Vergleich zum Vorjahr',
        },
        charts: {
            performance: 'Leistungsübersicht',
            loanAmount: 'Bewertungssumme',
            totalAmount: 'Bewertungssumme',
            commission: 'Provision',
            loanTypeDistribution: 'Verteilung nach Kreditart',
            monthlyComparison: 'Monatlicher Vergleich',
            evaluation: 'Bewertung',
            loanCount: 'Anzahl Kredite',
            locationPerformance: 'Gesamtbewertung',
            averageCommission: 'Durchschnittliche Provision'
        },
        tables: {
            bankPerformance: 'Bankenübersicht',
            poolerPerformance: 'Poolerübersicht',
            customerPerformance: 'Top 5 Kunden',
            referrerPerformance: 'Top 10 Makler',
            consultantRankings: 'Berater Ranking',
            locationRankings: 'Standort Ranking',
            columns: {
                rank: 'Rang',
                name: 'Name',
                bank: 'Bank',
                pooler: 'Pooler',
                customer: 'Kunde',
                referrer: 'Makler',
                city: 'Stadt',
                loans: 'Vorgänge',
                amount: 'Kreditsumme',
                avgAmount: 'Ø Kreditsumme',
                totalAmount: 'Gesamtsumme',
                commission: 'Provision',
                location: 'Standort',
                consultants: 'Berater',
                loansPerConsultant: 'Vorgänge pro Berater',
                totalEvaluation: 'Gesamtbewertung'
            }
        },
        months: {
            1: 'Januar',
            2: 'Februar',
            3: 'März',
            4: 'April',
            5: 'Mai',
            6: 'Juni',
            7: 'Juli',
            8: 'August',
            9: 'September',
            10: 'Oktober',
            11: 'November',
            12: 'Dezember'
        },
        rechartsVersion: 'Diagramm Gesamtbewertung',
        bank: 'Bank',
        pooler: 'Pooler',
        totalLoanAmount: 'Gesamtkreditsumme',
        loanCount: 'Anzahl Vorgänge',
        avgLoanAmount: 'Ø Kreditsumme',
        avgProvisionPercentage: 'Ø Provision %',
        totalEvaluation: 'Gesamtbewertung',
        bankAnalytics: 'Banken Auswertung',
        bankAnalyticsSubtitle: 'Analyse der Kreditperformance nach Bank und Pooler',
        total: 'Gesamt'
    },
    my_analytics: {
        title: 'Meine Auswertung',
        subtitle: 'DEMOSEITE',
        filters: {
            year: 'Jahr',
            location: 'Standort',
            allLocations: 'Alle Standorte',
            consultant: 'Berater',
            compareYear: 'Vergleiche mit Jahr'
        },
        kpis: {
            totalAmount: 'Gesamtkreditsumme',
            totalLoans: 'Anzahl Vorgänge',
            avgAmount: 'Ø Kreditsumme',
            totalCommission: 'Gesamtprovision',
            withdrawalRate: 'Widerrufsquote',
            conversionRate: 'Abschlussquote',
            avgTimeToClose: 'Ø Tage Unterschrift bis Auszahlung',
            yearlyGoalProgress: 'Jahresziel im Vergleich zum Vorjahr',
        },
        charts: {
            performance: 'Leistungsübersicht',
            loanAmount: 'Bewertungssumme',
            totalAmount: 'Bewertungssumme',
            commission: 'Provision',
            loanTypeDistribution: 'Verteilung nach Kreditart',
        },
        tables: {
            bankPerformance: 'Bankenübersicht',
            poolerPerformance: 'Poolerübersicht',
            customerPerformance: 'Top 5 Kunden',
            referrerPerformance: 'Top 10 Makler',
            columns: {
                rank: 'Rang',
                name: 'Name',
                bank: 'Bank',
                pooler: 'Pooler',
                customer: 'Kunde',
                referrer: 'Makler',
                city: 'Stadt',
                loans: 'Vorgänge',
                amount: 'Kreditsumme',
                avgAmount: 'Ø Kreditsumme',
                totalAmount: 'Gesamtsumme',
                commission: 'Provision',
            }
        },
        bank: 'Bank',
        pooler: 'Pooler',
        totalLoanAmount: 'Gesamtkreditsumme',
        loanCount: 'Anzahl Vorgänge',
        avgLoanAmount: 'Ø Kreditsumme',
        avgProvisionPercentage: 'Ø Provision %',
        totalEvaluation: 'Gesamtbewertung',
        bankAnalytics: 'Banken Auswertung',
        bankAnalyticsSubtitle: 'Analyse der Kreditperformance nach Bank und Pooler',
        total: 'Gesamt'
    },    
    withdrawalPassed: {
        title: 'Widerrufsfrist abgelaufen',
        subtitle: 'Vorgänge mit abgelaufener Widerrufsfrist.',
        addInvoice: 'Rechnung erstellen',
        addStatement: 'Abrechnung eintragen'
    },
    paymentConfirmed: {
        title: 'Vorgänge die überwiesen wurden',
        subtitle: 'Zahlungseingang vermerken.',
        confirmPayment: 'Zahlungseingang vermerken',
        addStatement: 'Abrechnung eintragen',
        metrics: {
            totalCommission: 'Gesamt Provision',
            totalAmount: 'Gesamtsumme',
            totalExtraBonus: 'Gesamt Bonus'
        }
    },
    consultantBilling: {
        title: 'Beraterabrechnung',
        subtitle: 'Hier kannst du die Beraterabrechnungen verwalten.',
        viewOverview: 'Zur Abrechnungsübersicht',
        markBilled: 'Abrechnung erstellen',
        addInvoice: 'Rechnung erstellen',
        totalSum: 'Gesamtsumme',
        primary_share: 'Hauptberater Anteil',
        temporary_share: 'Vertreter Anteil',
        withdrawal_share: 'Storno Anteil',
        metrics: {
            totalAmount: 'Gesamtsumme',
            totalCommission: 'Gesamt Provision',
            totalExtraBonus: 'Gesamt Bonus',
            totalPrimaryShare: 'Hauptberater Anteil',
            totalTemporaryShare: 'Vertreter Anteil',
            totalWithdrawalShare: 'Storno Anteil'
        },
        selectConsultantTitle: 'Berater auswählen',
        selectConsultantSubtitle: 'Wählen Sie einen Berater aus'
    },
    bank: {
        title: 'Banken',
        subtitle: 'HINWEIS! Diese Seite ist noch nicht komplett funktionsfähig. Dient nur als Diskussionsgrundlage ',
        addBank: 'Bank anlegen',
        search: 'Bank suchen',
        fields: {
            name: 'Name',
            street: 'Straße',
            zipCode: 'PLZ',
            city: 'Stadt',
            contactPerson: 'Ansprechpartner',
            email: 'E-Mail',
            phone: 'Telefon',
            additionalInfo: 'Zusätzliche Informationen'
        },
        modal: {
            title: 'Bank anlegen',
            editTitle: 'Bank bearbeiten'
        },
        messages: {
            createSuccess: 'Bank erfolgreich angelegt',
            createError: 'Fehler beim Anlegen der Bank',
            updateSuccess: 'Bank erfolgreich aktualisiert',
            updateError: 'Fehler beim Aktualisieren der Bank'
        }
    },
    referrer: {
        title: 'Vermittler/Makler',
        subtitle: 'HINWEIS! Diese Seite ist noch nicht komplett funktionsfähig. Dient nur als Diskussionsgrundlage ',
        add: 'Vermittler anlegen',
        search: 'Makler suchen',
        fields: {
            name: 'Nachname',
            firstName: 'Vorname',
            street: 'Straße',
            zipCode: 'PLZ',
            city: 'Stadt',
            company: 'Firma',
            email: 'E-Mail',
            phone: 'Telefon',
            mobile: 'Mobil',
            additionalInfo: 'Zusätzliche Informationen'
        },
        modal: {
            title: 'Bank anlegen',
            editTitle: 'Bank bearbeiten'
        },
        messages: {
            createSuccess: 'Bank erfolgreich angelegt',
            createError: 'Fehler beim Anlegen der Bank',
            updateSuccess: 'Bank erfolgreich aktualisiert',
            updateError: 'Fehler beim Aktualisieren der Bank'
        }
    },
    settings: {
        title: 'Einstellungen',
        subtitle: 'Pflegen der Benutzer- und Rechnungsdaten',
        save: 'Änderungen speichern',
        cancel: 'Abbrechen',
        saveSuccess: 'Einstellungen erfolgreich gespeichert',
        saveError: 'Fehler beim Speichern der Einstellungen',
        fetchError: 'Fehler beim Laden der Einstellungen',
        ibanRequired: 'Bitte geben Sie Ihre IBAN ein!',
        ibanInvalidLength: 'Die IBAN muss genau 22 Zeichen lang sein',
        ibanInvalidCountry: 'Die IBAN muss mit DE beginnen',
        ibanInvalidFormat: 'Die IBAN darf nur Buchstaben und Zahlen enthalten',
    },
    myAnalytics: {
        title: 'Meine Jahresauswertung',
        subtitle: 'Persönliche Leistungsübersicht',
        filters: {
            year: 'Jahr',
        },
        kpis: {
            totalLoans: 'Anzahl Vorgänge',
            yearlyGrowth: 'Wachstum Vorgänge',
            totalEvaluation: 'Bewertungssumme',
            evaluationGrowth: 'Wachstum Bewertungssumme',
        },
        charts: {
            evaluation: 'Bewertungssumme',
            loanCount: 'Anzahl Vorgänge',
            monthlyComparison: 'Monatlicher Vergleich',
        },
        tables: {
            topReferrers: 'Top 10 Vermittler',
            columns: {
                rank: 'Rang',
                name: 'Name',
                loans: 'Vorgänge',
                avgAmount: 'Ø Kreditsumme',
                totalAmount: 'Gesamtsumme',
                commission: 'Ø Provision',
            }
        }
    },
};

export default de;
